import { supabase } from "@internal/auth";

// AI formulation help for Matpresiseringer: sends the user's draft fact
// to the suggest-clarification edge function and returns one polished
// Norwegian sentence. The caller always shows it for review — nothing
// is saved without the user accepting it.
export async function suggestClarification(draft: string): Promise<string> {
  const { data, error } = await supabase.functions.invoke(
    "suggest-clarification",
    { body: { draft } },
  );
  if (error) throw new Error("Forslag feilet. Prøv igjen.");
  const text = (data as { text?: unknown } | null)?.text;
  if (typeof text !== "string" || text.trim().length === 0) {
    throw new Error("Forslag ga et ugyldig svar.");
  }
  return text.trim();
}
